<div class="navbar navbar-light">
	<div class="navbar-brand">
		<span *ngIf="optionType.isHamburger" class="slide-bar-span d-inline-block align-top mr-2" (click)="showHideSlideBar()">
			<i class="fas fa-bars fa-fw slide-bar-i" aria-hidden="true"></i>
		</span>
		<img src="../../../assets/images/app_logo_with_icon1.png" width="180" height="50" class="d-inline-block align-top ml-1 mr-1"
			alt="">
	</div>
	<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent, #menubar"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
		(click)="showToggleMenu()">
		<i class="fa fa-ellipsis-v"></i>
	</button>
	<div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{'toggle-border-top': isToggleMenu}">
		<ul class="navbar-nav mr-auto">
		</ul>
		<div class="form-inline my-2 my-lg-0 float-right">
			<button class="btn btn-outline-header-primary btn-sm btn-circle my-2 my-sm-0 mr-1 ml-2"
            (click)="userSettingsPO.toggle()">
				<span [popover]="userSettingsContent" containerClass="user-setting" placement="bottom"
					#userSettingsPO="bs-popover" triggers="" container="body" [outsideClick]="true">{{loggedInUser.firstName | slice:0:1}}{{loggedInUser.lastName |
				slice:0:1}}</span>
			</button>
		</div>
	</div>
</div>
<hr class="mt-0 mb-2" style="height: 3px;background-color: #3fb5d4;"/>
<div class="collapse navbar-collapse topnav" id="menubar">
	<ul class="navbar-nav ">
		<div class="dropdown">
			<button class="dropbtn">Patient Reports
			<i class="fa fa-caret-down"></i>
			</button>
			<div class="dropdown-content">
				<a class="nav-link" style="min-width: 280px;" (click)="TBBO2TherapyReportBtn()">TBBO2 Oxygen Therapy Report</a>
				<a class="nav-link" style="min-width: 280px;" (click)="TBBO2RecoveryTimeReportBtn()">TBBO2 Recovery Time Report</a>
			</div>
		</div>
		<div class="dropdown" [hidden] = !isSuperUser>
			<button class="dropbtn">Device
			<i class="fa fa-caret-down"></i>
			</button>
			<div class="dropdown-content">
			<a class="nav-link" (click)="ServiceCodesScanBtn()" [hidden] = !isSuperUser>Service Codes Scan</a>
			</div>
		</div>
		<div class="dropdown">
			<button class="dropbtn">My Account
			<i class="fa fa-caret-down"></i>
			</button>
			<div class="dropdown-content">
			<a class="nav-link" (click)="EditProfileBtn()">Edit Profile</a>
			<a class="nav-link" (click)="ChangePasswordBtn()">Change Password</a>
			<a class="nav-link" (click)="RequestDeleteProfileBtn()">Delete Profile</a>
			</div>
		</div>
		<div class="dropdown" [hidden] = isUser>
			<button class="dropbtn">Admin
			<i class="fa fa-caret-down"></i>
			</button>
			<div class="dropdown-content">
			<a class="nav-link" (click)="ManageClinicsBtn()" [hidden] = !isSuperUser>Manage Clinics</a>
			<a class="nav-link" (click)="ManageUsersBtn()">Manage Users</a>
        <a class="nav-link" (click)="ManageDeleteRequestsBtn()" [hidden] = !isSuperUser>Manage Delete Requests</a>
			<a class="nav-link" (click)="ManageMachinesBtn()"  >Manage Machines</a>
			<a class="nav-link" (click)="ManagePatientsBtn()" [hidden] = isSuperUser >Manage Patients</a>
			<a class="nav-link" (click)="ManagePasscodeBtn()">Manage Passcode</a>
			<a class="nav-link" (click)="ImportDataBtn()" [hidden] = isSuperUser>Import Data</a>
			</div>
		</div>
	</ul>
</div>
<ng-template #userSettingsContent>
	<div class="card col-sm-12 rounded-0 p-0 border-top-0 border-left-0 border-right-0 mt-2 mb-1">
		<div class="card-body row p-0">
			<div class="float-left mx-3 mb-2">
				<span class="btn btn-outline-header-primary btn-circle btn-sm float-left mt-1">
					{{loggedInUser.firstName | slice:0:1}}{{loggedInUser.lastName | slice:0:1}}</span>
			</div>
			<div class="float-left col mt-2">
				<div class="row">
					<div class="col-sm-12 pl-0">
						<p class="float-left mb-0"> {{loggedInUser.firstName + ' ' + loggedInUser.lastName}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row my-1 mx-0 py-1 px-3 user-settings-item" (click)="signOutBtnClickEvent()">
		<div class="float-left mx-2 text-muted">
			<i class="fa fa-sign-out" aria-hidden="true"></i>
		</div>
		<div class="float-left mx-2">
			<p class="m-0 ">Log Out</p>
		</div>
	</div>
	<hr class="m-1" />
	<div class="row my-1 mx-0 py-1 px-3 user-settings-item">
		<div class="float-left mx-2 text-muted">
			<i class="fa fa-info-circle" aria-hidden="true"></i>
		</div>
		<div class="float-left mx-2">
			<p class="m-0 ">App Version - {{appVersion}}</p>
		</div>
	</div>
	<hr class="m-1" />
	<div class="row my-1 mx-0 py-1 px-3 user-settings-item">
		<div class="float-left mx-2 text-muted">
			<i class="fa fa-info-circle" aria-hidden="true"></i>
		</div>
		<div class="float-left mx-2">
			<p class="m-0 ">Service Version - {{serviceVersion}}</p>
		</div>
	</div>
  <div class="row my-1 mx-0 py-1 px-3 user-settings-item" routerLink='/privacy'>
    <div class="float-left mx-2 text-muted">
      <i class="fa fa-list" aria-hidden="true"></i>

    </div>
    <div class="float-left mx-2">
      <a  class="m-0 " routerLink='/privacy' >Privacy Policy</a>

    </div>
  </div>
</ng-template>

